import React from 'react';

export default function EndingGlyph({ kind, color }) {
  const stroke = '#0F0F0F';
  const fill = color;
  switch (kind) {
    case 'ghost':
      return (
        <svg viewBox="0 0 120 120">
          <path d="M30 70 V40 a30 30 0 0 1 60 0 v30 l-10 10 -10-10 -10 10 -10-10 -10 10 -10-10z"
                fill={fill} stroke={stroke} strokeWidth="3" />
          <circle cx="50" cy="48" r="4" fill={stroke} />
          <circle cx="74" cy="48" r="4" fill={stroke} />
        </svg>
      );
    case 'puppet':
      return (
        <svg viewBox="0 0 120 120">
          <line x1="20" y1="10" x2="40" y2="50" stroke={stroke} strokeWidth="2" />
          <line x1="100" y1="10" x2="80" y2="50" stroke={stroke} strokeWidth="2" />
          <line x1="60" y1="10" x2="60" y2="40" stroke={stroke} strokeWidth="2" />
          <circle cx="60" cy="55" r="18" fill={fill} stroke={stroke} strokeWidth="3" />
          <rect x="42" y="73" width="36" height="36" fill={fill} stroke={stroke} strokeWidth="3" />
        </svg>
      );
    case 'exit':
      return (
        <svg viewBox="0 0 120 120">
          <rect x="30" y="20" width="60" height="80" fill={fill} stroke={stroke} strokeWidth="3" />
          <circle cx="76" cy="60" r="3" fill={stroke} />
          <path d="M50 60 h-30 m0 0 l8 -8 m-8 8 l8 8"
                stroke={stroke} strokeWidth="3" fill="none" strokeLinecap="round" />
        </svg>
      );
    case 'deck':
      return (
        <svg viewBox="0 0 120 120">
          <rect x="20" y="30" width="80" height="50" fill={fill} stroke={stroke} strokeWidth="3" />
          <line x1="60" y1="80" x2="60" y2="98" stroke={stroke} strokeWidth="3" />
          <line x1="40" y1="98" x2="80" y2="98" stroke={stroke} strokeWidth="3" />
          <path d="M30 60 l10 -8 l10 6 l12 -14 l12 8 l16 -10"
                stroke={stroke} strokeWidth="3" fill="none" />
        </svg>
      );
    case 'tumbleweed':
      return (
        <svg viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="32" fill={fill} stroke={stroke} strokeWidth="3" />
          <path d="M30 60 q15 -20 60 0 M30 60 q15 20 60 0 M50 30 q5 30 5 60 M70 30 q-5 30 -5 60"
                stroke={stroke} strokeWidth="2" fill="none" />
        </svg>
      );
    case 'scope':
      return (
        <svg viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="48" fill={fill} stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="60" r="32" fill="none" stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="60" r="16" fill="none" stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="60" r="3" fill={stroke} />
        </svg>
      );
    case 'candle':
      return (
        <svg viewBox="0 0 120 120">
          <rect x="48" y="50" width="24" height="60" fill={fill} stroke={stroke} strokeWidth="3" />
          <line x1="60" y1="50" x2="60" y2="40" stroke={stroke} strokeWidth="3" />
          <path d="M55 40 q5 -14 10 0 q-5 6 -10 0" fill={fill} stroke={stroke} strokeWidth="2" />
          <path d="M40 110 q-12 4 -20 0 M80 110 q12 4 20 0"
                stroke={stroke} strokeWidth="2" fill="none" />
        </svg>
      );
    case 'spiral':
      return (
        <svg viewBox="0 0 120 120">
          <path d="M60 60 m0 -3 a3 3 0 1 1 -3 3 a6 6 0 1 0 6 -6 a9 9 0 1 1 -9 9 a12 12 0 1 0 12 -12 a15 15 0 1 1 -15 15 a18 18 0 1 0 18 -18 a22 22 0 1 1 -22 22"
                fill="none" stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="60" r="48" fill={fill} opacity=".3" />
        </svg>
      );
    case 'crown':
      return (
        <svg viewBox="0 0 120 120">
          <path d="M20 80 L30 40 L50 60 L60 30 L70 60 L90 40 L100 80 Z"
                fill={fill} stroke={stroke} strokeWidth="3" />
          <rect x="20" y="80" width="80" height="14" fill={fill} stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="34" r="3" fill={stroke} />
        </svg>
      );
    case 'rocket':
      return (
        <svg viewBox="0 0 120 120">
          <path d="M60 12 q22 22 22 50 v22 H38 V62 q0 -28 22 -50 z"
                fill={fill} stroke={stroke} strokeWidth="3" />
          <circle cx="60" cy="56" r="8" fill="#fff" stroke={stroke} strokeWidth="3" />
          <path d="M38 80 L24 100 h14 z M82 80 L96 100 H82 z"
                fill={fill} stroke={stroke} strokeWidth="3" />
          <path d="M50 92 q10 14 20 0" fill="none" stroke={stroke} strokeWidth="3" />
        </svg>
      );
    case 'shield':
      return (
        <svg viewBox="0 0 120 120">
          <path d="M60 14 L100 28 V64 q0 28 -40 42 q-40 -14 -40 -42 V28 z"
                fill={fill} stroke={stroke} strokeWidth="3" />
          <path d="M44 60 l12 12 l22 -26"
                stroke={stroke} strokeWidth="4" fill="none"
                strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'compass':
      return (
        <svg viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="44" fill={fill} stroke={stroke} strokeWidth="3" />
          <path d="M60 28 L70 60 L60 92 L50 60 Z" fill={stroke} />
          <circle cx="60" cy="60" r="4" fill="#fff" stroke={stroke} strokeWidth="2" />
        </svg>
      );
    case 'calendar':
    default:
      return (
        <svg viewBox="0 0 120 120">
          <rect x="20" y="28" width="80" height="76" fill={fill} stroke={stroke} strokeWidth="3" />
          <rect x="20" y="28" width="80" height="18" fill={stroke} />
          <line x1="36" y1="20" x2="36" y2="40" stroke={stroke} strokeWidth="4" strokeLinecap="round" />
          <line x1="84" y1="20" x2="84" y2="40" stroke={stroke} strokeWidth="4" strokeLinecap="round" />
          <text x="60" y="84" textAnchor="middle" fontFamily="Inter, sans-serif"
                fontWeight="900" fontSize="32" fill={stroke}>90</text>
        </svg>
      );
  }
}
